import  React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import presentation1 from "../static/img/presentation1.jpg";
import presentation2 from "../static/img/presentation2.jpg";
import presentation3 from "../static/img/presentation3.jpg";
import presentation4 from "../static/img/presentation4.jpg";
import presentation5 from "../static/img/presentation5.jpg";
//import presentation6 from "../static/img/presentation6.jpg";

import "./Microcredit.style.scss";

const PodilskieReadings: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Presentation of the DOMANI project at the conference PODILSKIE READINGS – 2025 (Ukraine) 6.11.2025" :
                    "Презентація проєкту ДОМАНІ на конференції ПОДІЛЬСЬКІ ЧИТАННЯ – 2025 (Україна) 6.11.2025"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? "On November 6, 2025, at the plenary session of the XI International Scientific and Practical" +
                    " Conference PODIL READINGS – 2025 “Scientific Space: Interdisciplinary Directions and Strategies" +
                    " for the Development of Territorial Communities”, which was held in Ternopil (Ukraine)," +
                    " Prof. Nadiya Maksymenko (V.N. Karazin Kharkiv National University) spoke about the features of" +
                    " the DOMANI project. A short article was published in the conference materials Maksymenko Nadiya," +
                    " Cherkashyna Nadiya THE ROLE OF INTERNATIONAL GRANT PROJECTS IN FORMING MODERN TRENDS IN GEOECOLOGICAL" +
                    " EDUCATION AND ENLIGHTENMENT" :
                    "6 листопада 2025 року на пленарному засіданні ХІ Міжнародної науково-практичної конференції" +
                    " ПОДІЛЬСЬКІ ЧИТАННЯ – 2025 «Науковий простір: міждисциплінарні напрями та стратегії розвитку" +
                    " територіальних громад», що проходила у м. Тернопіль (Україна) про особливості проєкту ДОМАНІ" +
                    " розповіла проф. Надія Максименко (Харківський національний університет імені В.Н. Каразіна)." +
                    " Опубліковано в матеріалах конференції коротку статтю Максименко Надія, Черкашина Надія  РОЛЬ" +
                    " МІЖНАРОДНИХ ГРАНТОВИХ ПРОЄКТІВ У ФОРМУВАННІ СУЧАСНИХ ТРЕНДІВ ГЕОЕКОЛОГІЧНОЇ ОСВІТИ І ПРОСВІТНИЦТВА"
                }
            </p>

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px',width:"84%",margin:"0 auto"}}>
                <img src={presentation1} alt="presentation" style={{ width: '100%' }} />
                <img src={presentation3} alt="presentation" style={{ width: '100%' }} />
                <img src={presentation2} alt="presentation" style={{ width: '100%' }} />
                <img src={presentation4} alt="presentation" style={{ width: '100%' }} />
                <img src={presentation5} alt="presentation" style={{ width: '100%' }} />
                {/*<img src={presentation6} alt="presentation" style={{ width: '100%' }} />*/}
            </div>
        </div>
    )
}
export default PodilskieReadings;